import Welcome from './Welcome.container'

export default Welcome
